var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadDPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 364.6,
    height: 477.96,
    viewBox: "0 0 364.6 477.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #020202;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136,6.17V135.54c.24,3.48,1.33,23.36-10.63,40.31-11.42,16.2-26.51,18-29.53,18.33H5.2",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136,484.13V354.76c.24-3.48,1.33-23.37-10.63-40.31-11.42-16.2-26.51-18-29.53-18.33H5.2",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239,6.17V135.54c-.24,3.48-1.33,23.36,10.63,40.31,11.42,16.2,26.51,18,29.53,18.33H369.8",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239,484.13V354.76c-.24-3.48-1.33-23.37,10.63-40.31,11.42-16.2,26.51-18,29.53-18.33H369.8",
    transform: "translate(-5.2 -6.17)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.55,467.41v15.92a.72.72,0,0,1-.63.79.7.7,0,0,1-.78-.62.48.48,0,0,1,0-.17V467.41a.71.71,0,0,1,.62-.79.72.72,0,0,1,.79.63Z",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.34,466.77l6.89,6.89a.71.71,0,0,1-1,1l-6.39-6.39-6.34,6.38a.72.72,0,0,1-1,0,.71.71,0,0,1,0-1l6.89-6.89A.72.72,0,0,1,220.34,466.77Z",
    transform: "translate(-5.2 -6.17)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.74,22.88V7a.7.7,0,0,0-.62-.78.71.71,0,0,0-.79.62V22.88a.72.72,0,0,0,.63.79.7.7,0,0,0,.78-.62A.48.48,0,0,0,155.74,22.88Z",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.53,23.52l6.89-6.89a.7.7,0,0,0,0-1,.74.74,0,0,0-1,0L155,22l-6.34-6.38a.74.74,0,0,0-1,0,.85.85,0,0,0-.2.5.72.72,0,0,0,.2.49l6.89,6.89A.7.7,0,0,0,155.53,23.52Z",
    transform: "translate(-5.2 -6.17)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.92,279.34H6a.71.71,0,1,1-.17-1.41H21.92a.71.71,0,1,1,.16,1.41A.43.43,0,0,1,21.92,279.34Z",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.56,279.13,15.67,286a.7.7,0,0,1-1,0,.72.72,0,0,1,0-1l6.39-6.39-6.38-6.34a.72.72,0,0,1,0-1,.75.75,0,0,1,.5-.2.7.7,0,0,1,.49.2l6.89,6.89A.72.72,0,0,1,22.56,279.13Z",
    transform: "translate(-5.2 -6.17)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.08,214.34H369a.71.71,0,1,0,.17-1.41.48.48,0,0,0-.17,0H353.08a.71.71,0,0,0-.79.62.72.72,0,0,0,.63.79Z",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.44,214.13l6.89,6.89a.71.71,0,0,0,1-1l-6.39-6.39,6.38-6.34a.72.72,0,0,0,0-1,.71.71,0,0,0-1,0l-6.89,6.89A.72.72,0,0,0,352.44,214.13Z",
    transform: "translate(-5.2 -6.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadDPhoto);
export default __webpack_public_path__ + "static/media/road-D-photo.6351506dd7e0472f1e6c84f63942dce8.svg";
export { ForwardRef as ReactComponent };